import { render, staticRenderFns } from "./DialogRealizadoDetalhamento.vue?vue&type=template&id=b39ea8ea"
import script from "./DialogRealizadoDetalhamento.vue?vue&type=script&lang=js"
export * from "./DialogRealizadoDetalhamento.vue?vue&type=script&lang=js"
import style0 from "./DialogRealizadoDetalhamento.vue?vue&type=style&index=0&id=b39ea8ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports